export default __webpack_public_path__ + "static/media/emotion.6f7f8655.jpeg";